<template>
  <div>
    <MediaSubheader />
    <Layout class="layout-spacing">
      <AdminOnly>
        <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />
        <Dropdown class="mb-5" />
      </AdminOnly>

      <FeaturedPressReleases />
      <PressReleases />
      <Articles />
      <FeaturedVideos />
      <Images />
      <HeadshotsAndLogos />

      <Contact />
    </Layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AdminOnly from "../AdminOnly.vue";
import MediaSubheader from "./MediaSubheader";
import PressReleases from "./PressReleases/PressReleases.vue";
import FeaturedPressReleases from "./PressReleases/FeaturedPressReleases.vue";
import FeedbackMessage from "../FeedbackMessage";
import Layout from "../Layout.vue";
import FeaturedVideos from "./Videos/FeaturedVideos.vue";
import Contact from "./Contact.vue";
import Articles from "./Articles/Articles.vue";
import Dropdown from "../Dropdown.vue";
import Images from "./Images.vue";
import HeadshotsAndLogos from "./HeadshotsAndLogos.vue";

export default {
  name: "Media",

  components: {
    MediaSubheader,
    PressReleases,
    FeaturedPressReleases,
    FeedbackMessage,
    AdminOnly,
    Layout,
    Contact,
    FeaturedVideos,
    Articles,
    Dropdown,
    Images,
    HeadshotsAndLogos,
  },

  computed: {
    ...mapGetters(["feedback"]),
  },
  methods: {
    ...mapActions(["resetFeedback"]),
  },
};
</script>

<style lang="scss" scoped>
.layout-spacing {
  padding-top: 4rem;

  @media screen and (max-width: 1280px) {
    padding-top: 8rem;
  }

  @media screen and (max-width: 1200px) {
    padding-top: 5rem;
  }

  @media screen and (max-width: 1025px) {
    padding-top: 7rem;
  }

  @media screen and (max-width: 770) {
    padding-top: 4rem;
  }
}
</style>
